module.exports = __webpack_public_path__ + "img/activity15.f6826e25.jpg";